<template>
  <div class="header_wrap" v-if="$route.name !== 'unionrecord' && $route.name !== 'vipexchange' && $route.name !== 'activityRule' && $route.name !== 'cctvRights'">
    <img src="https://images.zhibo.tv/2021/0514/goback_icon.png" @click="goBack" alt="">
    {{title}}
  </div>
  <div v-else class="header_wrap pay_recode_header">
    <img src="https://images.zhibo.tv/2020/0604/back_icon.png" @click="goBack" alt="">
    {{title}}
  </div>
</template>
<script>

export default {
  props: ['titleName'],
  data() {
    return {
      title: ''
    }
  },
  created() {
    this.title = this.titleName ? this.titleName : this.$route.meta.title
    if (this.$route.name !== 'unionrecord' && this.$route.name !== 'vipexchange' && this.$route.name !== 'activityRule' && this.$route.name !== 'cctvRights') {
      this.changeStatusbar("#18181A", 0)
    } else {
      this.changeStatusbar("#ffffff", 1)
    }
  },
  methods: {
    goBack() {
      if (window.location.href.indexOf('/unionvip') == -1) {
        this.$router.back()
      } else {
        this.closeLayer()
      }
    },
    // 关闭当前层
    closeLayer () {
      var params = "close";
      try {
        window.webkit.messageHandlers.closeLayer.postMessage(params);
      } catch (e) {
        console.log("ios关闭失败");
      }
      try {
        window.LiveAppJS.closeLayer(params);
      } catch (e) {
        console.log("Android关闭失败");
      }
    },
    // 两端修改状态栏的方法
    changeStatusbar (bgcolor, wordcolor) {
      var iosParam = {
        "bgcolor": bgcolor,
        "wordcolor": wordcolor
      };
      try {
        window.webkit.messageHandlers.changeStatusbar.postMessage(iosParam);
      } catch (e) {
        console.log('ios修改状态栏颜色失败', iosParam);
      }
      try {
        window.LiveAppJS.changeStatusbar(bgcolor, wordcolor);
      } catch (e) {
        console.log('安卓修改状态栏颜色失败', bgcolor);
      }
      try {
        let query = JSON.stringify({"command": "isFontColorDark", "params": { "isDark": wordcolor }})
        window.LiveAppJS.nativeAction(query)
      } catch (e) {
        console.log('安卓修改状态栏颜色失败', bgcolor,wordcolor);
      }
    }
  }
}
</script>
<style lang="less" scoped>
.header_wrap {
  height: .88rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .34rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: .48rem;
  position: sticky;
  top: 0;
  z-index: 999;
  background: #18181A;
  img {
    position: absolute;
    left: .3rem;
    width: .2rem;
    height: .36rem;
  }
}
.pay_recode_header {
  background: #ffffff;
  color: #333333;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  box-shadow: 0px .01rem 0px 0px #E5E5E5;
}
</style>
